/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORTS : WIRE TRANSFER : STYLES --------------- ++++++++++ */
export default theme =>({
    wiretransfer:{
        '& .griditem': {
            marginRight: pxToEm(30),
            marginTop: pxToEm(20),
            width: '100%',
            maxWidth: pxToEm(469),
            '& .field':{
                width: '100%',
                maxWidth: pxToEm(469)
            }
        }
    }
});
